import { useEffect } from 'preact/hooks'
import { usePageHeader } from '@/hooks/usePageHeader'
import { KnowledgeBasePanel } from './KnowledgeBasePanel'
import { KnowledgeBaseLevel } from '@/types/knowledgeBase'

interface Props {
  clientCompanyId: string
  workspaceId: string
}

export function KnowledgeBasePage({ clientCompanyId, workspaceId }: Props) {
  const { setHeader } = usePageHeader()

  useEffect(() => {
    setHeader({ items: [{ text: 'Knowledge Base' }] })
  }, [])

  return (
    <div className="p-6">
      <KnowledgeBasePanel
        clientCompanyId={clientCompanyId}
        workspaceId={workspaceId}
        level={KnowledgeBaseLevel.Workspace}
      />
    </div>
  )
}
